import { Controller } from "@hotwired/stimulus";

// Member picker: live selection in inline mode, Save in drawer mode.
export default class extends Controller {
  static targets = ["checkbox", "saveButton", "list"];
  static values = { searchUrl: String, inline: Boolean };

  connect() {
    this.searchTimer = null;
  }

  toggle() {
    // Selection is tracked via checkbox state
  }

  closeInline() {
    document.dispatchEvent(new CustomEvent("member-picker:close"));
  }

  // Live selection: dispatch on every checkbox change when inline
  onSelectionChange() {
    if (!this.inlineValue) return;
    this.dispatchSelection();
  }

  dispatchSelection() {
    const checkboxes = this.element.querySelectorAll('[data-member-picker-target="checkbox"]:checked');
    const members = Array.from(checkboxes).map((cb) => {
      const label = cb.closest("label");
      return {
        id: parseInt(cb.value, 10),
        name: label?.dataset.memberName || "",
      };
    });
    document.dispatchEvent(
      new CustomEvent("member-picker:save", { detail: { members } })
    );
  }

  search(event) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      const form = this.element.querySelector("form");
      if (form) {
        const input = form.querySelector('input[name="q"]');
        if (input) form.submit();
      }
    }, 250);
  }

  save() {
    this.dispatchSelection();
  }
}
